<template>
<!-- 入驻管理 -->
<section class="viewContainer">
  <div v-show="isOrder" @listenEdit="showOrder">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :model="filters" class="findform">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:23%" label="主体名称：">
            <el-input v-model="filters.EnterpriseName" placeholder="请输入主体名称" maxlength="20" style="width:90%"/>
          </el-form-item>
          <el-form-item style="display:flex;width:23%" label="联系人电话：">
            <el-input v-model="filters.partnerPhone" placeholder="请输入联系人电话" maxlength="11" style="width:90%" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')"/>
          </el-form-item>
          <el-form-item style="display:flex;width:23%;" label="主体性质：">
            <el-select v-model="filters.partnerGender" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in genderArr" :key="index" :label="item.Name" :value="item.Id" />
            </el-select>
          </el-form-item>
          <el-form-item style="display:flex;width:23%;" label="入驻类型：">
            <el-select v-model="filters.ruzhuType" filterable placeholder="请选择" style="width:90%">
              <el-option v-for="(item,index) in ruzhuTypeArr" :key="index" :label="item.Name" :value="item.Id" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-form class="findform">
          <el-form-item label="所属城市：" style="display:flex;width:23%;">
            <!-- <el-input v-model="filters.partnerRegion" placeholder="请输入城市" maxlength="20"
              style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"/> -->
            <el-cascader v-model="filters.partnerRegion" placeholder="请选择城市" :options="ssOptions"
            style="width:90%" filterable clearable @change="handleChange"/>
          </el-form-item>
          <el-form-item label="入驻日期：" style="display:flex;width:23%">
            <el-date-picker type="daterange" :title="value6" v-model="value6" value-format="yyyy-MM-dd" @change="changetime"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:90%"  :picker-options="pickerOptions" />
          </el-form-item>
          <el-form-item label="上级管理：" style="display:flex;width:23%">
            <el-input v-model="filters.sjgl" placeholder="请输入上级管理" maxlength="20" style="width:90%"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <el-col :span="18"> <p class="model_top_title">入驻管理</p> </el-col>
      </section>
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="50">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="入驻类型" align="center">
            <template scope="scope">{{scope.row.bbTypeName}}</template>
          </el-table-column>
          <el-table-column label="主体类型" align="center">
            <template scope="scope">{{scope.row.enterpriseAttribute}}</template>
          </el-table-column>
          <el-table-column label="主体名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系人姓名" align="center">
            <template scope="scope">{{scope.row.legalPerson}}</template>
          </el-table-column>
          <el-table-column label="联系人电话" align="center">
            <template scope="scope">{{scope.row.legalPersonPhone}}</template>
          </el-table-column>
          <el-table-column label="所属城市" align="center" width="220">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
          <el-table-column label="店铺数量" align="center" width="80">
            <template scope="scope">{{scope.row.storeCount}}</template>
          </el-table-column>
          <el-table-column label="入驻渠道" align="center">
            <template scope="scope">{{scope.row.sourceType}}</template>
          </el-table-column>
          <el-table-column label="入驻时间" align="center">
            <template scope="scope">{{scope.row.entryTime}}</template>
          </el-table-column>
          <el-table-column label="上级管理" align="center">
            <template scope="scope">{{scope.row.parent}}</template>
          </el-table-column>
          <!-- <el-table-column label="性质" align="center">
            <template scope="scope">{{scope.row.enterpriseAttribute}}</template>
          </el-table-column> -->
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.stateName}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="160">
            <template scope="scope">
              <span class="handle" @click="cliSeePartner(scope.row,1)" v-show="scope.row.state == 2"> <i class="el-icon-edit-outline"/> 编辑 </span>
              <span class="handle" @click="cliSeePartner(scope.row,2)"> <i class="el-icon-view"/> 查看 </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-size="10" :total="totalRowsCount" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>

  <!-- 查看基本信息详情页 -->
  <section class="main_container" v-if="isSeePartnerPopup">
    <section class="model_section">
      <el-col :span="14"> <p class="model_top_title">入驻详情</p> </el-col>
    </section>
    <!-- 基本信息 -->
    <div class="watch_msg">
      <b class="typeface">基本信息</b>
      <el-form label-width="130px">
        <el-row>
          <el-col :span="12">
          <el-form-item label="主体名称：">
            <el-input v-model="essentialInformation.name" maxlength="20" :disabled="seeDis"
            placeholder="请输入主体名称" style="width: 60%;"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="主体类型：">
            <!--  @change="radioType" -->
            <el-radio-group v-model="essentialInformation.enterpriseAttribute" :disabled="seeDis">
              <el-radio :label="1">企业</el-radio>
              <el-radio :label="2">个体工商户</el-radio>
              <el-radio :label="3">个人</el-radio>
            </el-radio-group>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="所属城市：">
            <el-cascader v-model="essentialInformation.address" placeholder="请选择城市" :options="jyqyOptions"
              filterable clearable @change="handlejyqy" style="width: 60%" :disabled="seeDis"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="上级合伙人：">
            <el-input v-model="essentialInformation.parent" maxlength="20"
            placeholder="无" style="width: 60%;" disabled/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="法人姓名：">
            <el-input v-model="essentialInformation.legalPersonName" maxlength="20"
            placeholder="请输入法人姓名" style="width: 60%;" :disabled="seeDis"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="法人身份证号码：">
            <el-input v-model="essentialInformation.legalPersonIdCardNumber" maxlength="18"
            placeholder="请输入法人身份证号码" style="width: 60%;" :disabled="seeDis"/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="联系人姓名：">
            <el-input v-model="essentialInformation.legalPerson" maxlength="20"
            placeholder="请输入联系人姓名" style="width: 60%;" :disabled="seeDis"/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="联系方式：">
            <el-input v-model="essentialInformation.legalPersonPhone" maxlength="11"
            placeholder="请输入联系手机号" style="width: 60%;" :disabled="seeDis" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" />
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="入驻时间：">
            <el-input v-model="essentialInformation.entryTime" maxlength="20"
            placeholder="2022-11-04" style="width: 60%;" disabled/>
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="入驻渠道：">
            <el-input v-model="essentialInformation.sourceType" maxlength="20"
            placeholder="甄惠装小程序" style="width: 60%;" disabled/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-form-item label="企业介绍：">
            <el-input type="textarea" v-model="essentialInformation.desc" maxlength="500"
            placeholder="请输入企业介绍，最多输入500个字" style="width: 60%;" :disabled="seeDis" show-word-limit />
          </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="可开店数量：">
            <el-input v-model="essentialInformation.shopNum" maxlength="20"
            placeholder="请输入可开店数量" style="width: 60%;"/>
          </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          
          </el-col>
          <el-col :span="12">
            <el-form-item label="功能体验：" v-if="essentialInformation.state == 1 || isTrial==2">
              <el-checkbox v-model="essentialInformation.isTrial">体验</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <!-- 营业执照（身份证） -->
      <b class="typeface">营业执照（身份证）</b>
      <div class="upPictures">
        <div class="multigraph" v-for="(item,index) in yyzzImg" :key="index" :data-img="item">
          <el-image :src="item" class="seeLarge" fit="cover" @click="handleClickItem" :preview-src-list="yyzzImg"/>
          <div class="chahao" @click.stop="delImgCommon(index, 'yyzzImg', 'yyzzFlag')" v-show="seeSub"> <img src="../../assets/img/aicon36.png"/> </div>
        </div>
        <!-- 上传图片 -->
        <el-upload action multiple v-if="yyzzFlag < 5" :before-upload="beforeUploadYyzz" accept=".png, .jpg,.jpeg">
          <i class="el-icon-plus upBtn" v-if="seeSub"></i>
        </el-upload>
        <p class="spPicWenan" v-show="yyzzImg.length>0">请上传营业执照(身份证),支持JPG,PNG格式，单张图片最大5MB，最多上传5张</p>
      </div>
      <!-- 资质证书 -->
      <b class="typeface">资质证书</b>
      <div class="upPictures">
        <div class="multigraph" v-for="(item,index) in zzzsImg" :key="index" :data-img="item">
          <el-image :src="item" class="seeLarge" fit="cover" @click="handleClickItem" :preview-src-list="zzzsImg"/>
          <div class="chahao" @click.stop="delImgCommon(index, 'zzzsImg', 'zzzsFlag')" v-show="seeSub"> <img src="../../assets/img/aicon36.png"/> </div>
        </div>
        <!-- 上传图片 -->
        <el-upload action multiple v-if="zzzsFlag < 15" :before-upload="beforeUploadZzzs" accept=".png, .jpg,.jpeg">
          <i class="el-icon-plus upBtn" v-if="seeSub"></i>
        </el-upload>
        <p class="spPicWenan" v-show="zzzsImg.length>0">请上传资质证书或荣誉整数,支持JPG,PNG格式，单张图片最大5MB，最多上传15张</p>
      </div>
      <!-- 旗下店铺 -->
      <b class="typeface">旗下店铺</b>
      <div class="tempTabs" style="margin-bottom: 100px;">
        <el-table :data="BrandStoreList" border>
          <el-table-column label="线下店名" align="center">
            <template scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column label="管理者" align="center">
            <template scope="scope">{{scope.row.contacts}}</template>
          </el-table-column>
          <el-table-column label="管理者手机号" align="center">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="店铺管理员" align="center">
            <template scope="scope">{{scope.row.staffCount}}</template>
          </el-table-column>
          <!-- <el-table-column label="推广会员" align="center">
            <template scope="scope">{{scope.row.vipCount}}</template>
          </el-table-column>
          <el-table-column label="特价比例" align="center">
            <template scope="scope">{{scope.row.brandSpecialOfferCommissionRate}}</template>
          </el-table-column>
          <el-table-column label="普通比例" align="center">
            <template scope="scope">{{scope.row.brandOrdinaryCommissionRate}}</template>
          </el-table-column> -->
          <el-table-column label="总成交额" align="center">
            <template scope="scope">￥{{scope.row.profit}}</template>
          </el-table-column>
          <el-table-column label="详细地址" align="center">
            <template scope="scope">{{scope.row.address}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabTwo"
        :page-size="10" :current-page="pageIndexTabTwo" :total="totalTabTwo" class="paginationFy"/>
      </div>
      <!-- 提现记录 -->
      <!-- <div>
        <el-table :data="WithdrawalRecordList" class="watch_tab">
          <el-table-column label="提现日期" align="center">
            <template scope="scope">{{scope.row.applyTime}}</template>
          </el-table-column>
          <el-table-column label="绑定账户" align="center">
            <template scope="scope">{{scope.row.applyAccount}}</template>
          </el-table-column>
          <el-table-column label="提现金额" align="center">
            <template scope="scope">{{scope.row.amount}}</template>
          </el-table-column>
          <el-table-column label="提现状态" align="center">
            <template scope="scope">￥{{scope.row.state}}</template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleTabOne"
        :page-size="10" :current-page="pageIndexTabOne" :total="totalTabOne" class="paginationFy"/>
      </div> -->
    </div>
    <div class="gudingdibu">
      <el-button type="danger" v-if="essentialInformation.state == 1" @click="adoptToExamine(3)">拒绝通过</el-button>
      <el-button type="primary" v-if="essentialInformation.state == 1" @click="adoptToExamine(2)">审核通过</el-button>
      <el-button @click="showOrder()">{{ seeDis?'返回':'取消' }}</el-button>
      <el-button type="danger" @click="endPreservation()" v-show="seeSub">确定</el-button>
    </div>
  </section>
  
  <!-- 审核二次确认弹框 -->
  <el-dialog title="企业审核" :center="true" class="add_order_cancle" width="40%" :visible.sync="isToExamine">
    <el-form>
      <el-form-item>
        <el-input type="textarea" placeholder="请输入审核备注" maxlength="200" v-model="shenmark" :rows="3"             show-word-limit />
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" v-show="seeAdopt" @click="endToExamine(2)">确认审核</el-button>
      <el-button type="danger" v-show="seeRefuse" @click="endToExamine(3)">拒绝</el-button>
      <el-button @click="isToExamine = false">取 消</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, provincegetcountys } from '../../api/newOss';
import { getEnterprisePagination, getEnterpriseDetails, getEnterpriseWithdrawRecord,
  getStoreList, getQualification, putEnterprise, editEnterprise } from "../../api/attractInvestment";
export default {
  name: 'settledEnterprise',
  mixins: [alertTrends],
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }],
        disabledDate(time) {
          // 校准为当天0点0分0秒，仅禁用次日及以后的未来日期
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() >= today.getTime() + 24 * 3600 * 1000;
        }
      },
      show3: true, // 查询区域默认展开
      peopleId: "", // 企业id
      dataList: [], // 查询企业列表
      pageIndex: 1,
      pageSize: 10,
      totalRowsCount: 0,
      value6: "", // 入驻日期
      filters: {
        EnterpriseName: "", // 主体名称
        partnerPhone: "", // 联系人电话
        partnerGender: 0, // 主体性质
        ruzhuType: 0, // 入驻类型
        partnerRegion: "", // 城区
        date1: "",
        date2: "",
        sjgl: '', // 上级管理
      },
      genderArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "企业"
        },
        {
          Id: 2,
          Name: "个体工商户"
        },
        {
          Id: 3,
          Name: "个人"
        }
      ],
      ruzhuTypeArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "品牌建材"
        },
        {
          Id: 2,
          Name: "装修公司"
        },
        {
          Id: 3,
          Name: "个人设计师"
        }
      ],
      ssOptions: [],
      shengId: 0, // 省id
      shiId: 0, // 市id
      isOrder: true, // 列表页
      isSeePartnerPopup: false, // 查看
      essentialInformation: [], // 详情基本信息
      jyqyOptions: [],
      provinceId: 0, // 省id
      cityId: 0, // 市id
      zoneId: 0, // 区、县id
      seeDis: false, // 查看进来时：按钮置灰
      seeSub: true, // 查看进来时：保存按钮 & 删除按钮显隐逻辑

      WithdrawalRecordList: [], // 提现记录列表
      pageIndexTabOne: 1, // 提现记录分页
      totalTabOne: 0,

      BrandStoreList: [], // 品牌店列表
      pageIndexTabTwo: 1, // 品牌店分页
      totalTabTwo: 0,
      yyzzImg: [], // 营业执照-多图集合
      yyzzFlag: 0,
      zzzsImg:[], // 资质证书
      zzzsFlag: 0,
      isToExamine: false, // 审核弹框
      shenmark: "", // 审核意见
      seeAdopt: false, // 通过按钮
      seeRefuse: false, // 拒绝按钮
      isTrial: '',
    }
  },
  methods: {
    // 显示主页
    showOrder() {
      this.isOrder = true; // 主页
      this.isSeePartnerPopup = false; // 详情页查看
    },
    // 查询企业列表
    getInit() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
        name: this.filters.EnterpriseName, // 主体名称
        phone: this.filters.partnerPhone, // 联系人电话
        enterpriseAttribute: this.filters.partnerGender, // 主体性质 1=企业、2=个体工商户、3=个人
        bbType: this.filters.ruzhuType, // 入驻类型 1=品牌建材、2=装修公司、3=个人设计师
        // address: this.filters.partnerRegion, // 城区
        provinceId: this.shengId, // 省份id
        cityId: this.shiId, // 城市id
        beginTime: this.filters.date1, // 入驻开始时间
        endTime: this.filters.date2, // 入驻结束时间
        superiorName: this.filters.sjgl, // 上级管理名称
        pageIndex: this.pageIndex,// 页码
        pageSize: this.pageSize // 每页行数
      };
      getEnterprisePagination(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj.resultObj;
            this.totalRowsCount = data.resultObj.rowsCount;
          } else {
            this.dataList = [];
            this.totalRowsCount = 0;
          }
        } else {
          this.dataList = [];
          this.totalRowsCount = 0;
        }
      })
    },
    // 查看 & 编辑
    cliSeePartner(row,tyoe) {
      this.peopleId = row.id; // 企业Id
      this.isOrder = false; // 主页
      this.isSeePartnerPopup = true; // 详情页查看
      this.queryOrderDetail(); // 查询详情
      
      this.totalTabTwo = 0;
      this.queryBrandStore(); // 旗下店铺
      this.queryYyzz(); // 营业执照
      this.queryQualifications(); // 查询资质证书
      this.totalTabOne = 0;
      // this.queryWithdrawal(); // 查询提现记录
      
      let newType = tyoe; // 区分编辑&查看
      if(newType == 1) { // 编辑
        this.seeDis = false; // 文本框置灰
        this.seeSub = true; // 按钮显示
      } else { // 查看
        this.seeDis = true; // 文本框置灰
        this.seeSub = false; // 按钮隐藏
      }
    },
    // 查看详情
    queryOrderDetail(){
      var addParams = {
        id: this.peopleId // 企业Id
      };
      getEnterpriseDetails(addParams).then(data => {
        this.essentialInformation = data.resultObj;
        this.essentialInformation.address = [data.resultObj.provinceId,data.resultObj.cityId,data.resultObj.zoneId]; // 省市区
        this.essentialInformation.isTrial=this.essentialInformation.isTrial==2?true:false;
        this.isTrial=this.essentialInformation.isTrial==true?2:1;
        this.provinceId = data.resultObj.provinceId || ''; // 省id
        this.cityId = data.resultObj.cityId || ''; // 市id
        this.zoneId = data.resultObj.zoneId || ''; // 区县id
      })
    },
    // 保存提交
    endPreservation(){
      if(this.essentialInformation.name == ""){
        this.showAlert('请输入主体名称');
        return false
      }else if(this.essentialInformation.address == ''){
        this.showAlert('请选择经营区域');
        return false
      }else if(this.essentialInformation.legalPersonName == ''){
        this.showAlert('请输入法人姓名');
        return false
      }else if(this.essentialInformation.legalPersonIdCardNumber == ''){
        this.showAlert('请输入法人身份证号码');
        return false
      }else if(this.essentialInformation.legalPerson == ''){
        this.showAlert('请输入联系人姓名');
        return false
      }else if(this.essentialInformation.legalPersonPhone == ''){
        this.showAlert('请输入联系人电话');
        return false
      }else if(this.essentialInformation.desc == ''){
        this.showAlert('请输入企业介绍');
        return false
      }else if(this.essentialInformation.shopNum == ''){
        this.showAlert('请输入可开店数量');
        return false
      }else if(this.yyzzImg.length == 0){
        this.showAlert('请至少上传一张营业执照（身份证）');
        return false
      }
      // else if(this.zzzsImg.length == 0){
      //   this.showAlert('请至少上传一张资质证书');
      //   return false
      // }
      var obj = {
        updatesource: 1, // 操作来源 1=入驻企业详情页编辑 2=企业信息页保存 默认1
        id: this.peopleId, // 企业Id
        name: this.essentialInformation.name, // 主体名称
        enterpriseAttribute: this.essentialInformation.enterpriseAttribute, // 主体类型
        legalPersonName: this.essentialInformation.legalPersonName, // 法人姓名
        legalPersonIdCardNumber: this.essentialInformation.legalPersonIdCardNumber, // 法人身份证号码
        legalPerson: this.essentialInformation.legalPerson, // 联系人姓名
        legalPersonPhone: this.essentialInformation.legalPersonPhone, // 联系人电话
        desc: this.essentialInformation.desc, // 企业介绍
        shopNum: this.essentialInformation.shopNum, // 可开店数量
        istrial: this.essentialInformation.isTrial==true?2:1, // 功能体验
        provinceId: this.provinceId, // 省份id
        cityId: this.cityId, // 城市id
        zoneId: this.zoneId, // 区、县id
        businessLicense: this.yyzzImg.map(item=>item.replace(localStorage.BaseOssUrl,'')), // 营业执照相对路径集合
        qualifications: this.zzzsImg.map(item=>item.replace(localStorage.BaseOssUrl,'')), // 资质证书相对路径集合
       }
       editEnterprise(obj).then(data=>{
          if(data.resultCode == 1){
            this.showAlert('操作成功', 'success');
            this.isOrder = true; // 主页
            this.isSeePartnerPopup = false; // 详情页查看
            this.getInit();
          }
       });
    },
    // 旗下店铺
    queryBrandStore(){
      var addParams = {
        id: this.peopleId, // 企业Id
        pageIndex: this.pageIndexTabTwo,// 页码
        pageSize: 10 // 每页行数
      };
      getStoreList(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.BrandStoreList = data.resultObj.resultObj;
            this.totalTabTwo = data.resultObj.rowsCount; // 总行数
          } else {
            this.BrandStoreList = [];
          }
        } else {
            this.BrandStoreList = [];
        }
      })
    },
    // 营业执照
    queryYyzz(){
      var addParams = {
        id: this.peopleId, // 企业Id
        typeId: 1 // 资质类型 1=营业执照（身份证）、2=资质证书
      };
      getQualification(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.yyzzImg = data.resultObj;
            this.yyzzFlag = this.yyzzImg.length; // 集合长度
          } else {
            this.yyzzImg = [];
          }
        } else {
          this.yyzzImg = [];
        }
      })
    },
    // 资质证书
    queryQualifications(){
      var addParams = {
        id: this.peopleId, // 企业Id
        typeId: 2 // 资质类型 1=营业执照（身份证）、2=资质证书
      };
      getQualification(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.zzzsImg = data.resultObj;
            this.zzzsFlag = this.zzzsImg.length; // 集合长度
          } else {
            this.zzzsImg = [];
          }
        } else {
          this.zzzsImg = [];
        }
      })
    },
    // 提现记录
    queryWithdrawal(){
      var addParams = {
        id: this.peopleId, // 企业Id
        pageIndex: this.pageIndexTabOne,// 页码
        pageSize: 10 // 每页行数
      };
      getEnterpriseWithdrawRecord(addParams).then(data => {
        if(data) {
          if (data.resultCode == 1) {
            this.WithdrawalRecordList = data.resultObj.resultObj;
            this.totalTabOne = data.resultObj.rowsCount; // 总行数
          } else {
            this.WithdrawalRecordList = [];
          }
        } else {
            this.WithdrawalRecordList = [];
        }
      })
    },
    // 审核按钮
    adoptToExamine(val) {
      this.shenmark = ""; // 清空备注
      if(val == 2) {
        this.seeAdopt = true;
        this.seeRefuse = false;
      }else {
        this.seeRefuse = true;
        this.seeAdopt = false;
      }
      this.isToExamine = true; // 审核弹框展示
    },
    // 审核通过&拒绝
    endToExamine(stateVal) {
      if (this.shenmark == "") {
        this.showAlert('请输入审核备注');
        return false;
      }
      var addParams = {
        id: this.peopleId, // 企业Id
        state: stateVal, // 状态:2通过,3拒绝
        auditOpinion: this.shenmark, // 审核意见
        reviewerId: localStorage.Id, // 审核人Id
        shopNum: this.essentialInformation.shopNum, // 可开店数量
        istrial: this.essentialInformation.isTrial==true?2:1, // 功能体验
      };
      putEnterprise(addParams).then(data => {
        if(data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.isToExamine = false;
          this.isOrder = true; // 主页
          this.isSeePartnerPopup = false; // 详情页查看
          this.getInit();
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 请选择省市
    handleChange(val) {
      this.shengId = val[0];
      this.shiId = val[1];
    },
    // 查找省市
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let cityList = [];
        data.resultObj.forEach(item => {
          let cityData = { value: item.pid, label: item.pname, children: [] };
          cityList.push(cityData);
          item.citys.map(city => {
            cityData.children.push({ value: city.cid, label: city.cname });
          });
        });
        that.ssOptions = JSON.parse(JSON.stringify(cityList));

        // 不再向children数组中添加“全部”选项
        // that.ssOptions.map(item => {
        //   if(item.children.length > 1){
        //     item.children.unshift({ value: -1, label: '全部' });
        //   }
        // })

        // 添加“全国”选项到最前面
        that.ssOptions.unshift({ value: 0, label: '全国' });
        that.releaseCityOptions = cityList;
      })
    },
    // 请选择省市
    handlejyqy(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2];
    },
    // 查找省+市+区
    getSsq() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else {delete province.children;}
          provinceOptions.push(province);
        });
        this.jyqyOptions = provinceOptions;
        this.jyqyOptions.unshift({value: 0, label: "全国"});
      })
    },
    // 入驻日期
    changetime() {
      if(this.value6+""=="null"){
        this.value6 = ["",""]
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    // 重置
    fnReset() {
      this.filters = {
        EnterpriseName: "", // 主体名称
        partnerPhone: "", // 联系人电话
        partnerGender: 0, // 主体性质
        ruzhuType: 0, // 入驻类型
        partnerRegion: "", // 城区
        date1: "",
        date2: "",
        sjgl: '', // 上级管理
      }
      this.value6 = ''; // 入驻日期
      this.shengId = 0;
      this.shiId = 0; // 所属城市-市id
      // this.pageIndex = 1;
      // this.getInit();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getInit();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getInit();
    },
    // 查询tab1 分页
    handleTabOne(val) {
      this.pageIndexTabOne = val;
      this.getInit();
    },
    // 查询tab2 分页
    handleTabTwo(val) {
      this.pageIndexTabTwo = val;
      this.queryBrandStore();
    },
    // 多图上传-营业执照（身份证）
    beforeUploadYyzz(file) {
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 5MB');
        return;
      }
      this.yyzzFlag += 1;
      if (this.yyzzFlag > 5) {
        this.showAlert('最多传入5张图片');
        return false;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // oss 直传图片
        let obj = {
          type: 9
        };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
            uploadOSS(file,0).then(data => {
              var newOssPic = data;
              _this.yyzzImg.push(newOssPic);
            })
            
          }
        })
      };
    },
    // 多图上传-资质证书
    beforeUploadZzzs(file) {
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 <= 5;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 5MB');
        return;
      }
      this.zzzsFlag += 1;
      if (this.zzzsFlag > 15) {
        this.showAlert('最多传入15张图片');
        return false;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        // oss 直传图片
        let obj = {
          type: 9
        };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
            uploadOSS(file,0).then(data => {
              var newOssPic = data;
              _this.zzzsImg.push(newOssPic);
            })
            
          }
        })
      };
    },
    // 删除-营业执照（身份证）+删除-资质证书
    delImgCommon(index, imgArr, flagKey) {
      this[imgArr].splice(index, 1);
      this[flagKey] = this[imgArr].length; // 同步计数
    },

      // 删除-营业执照（身份证）
    // delYyzz(val) {
    //   let newUrl = this.yyzzImg;
    //   for (var i = 0; i < newUrl.length; i++) {
    //     if (val == i) {
    //       newUrl.splice(i, 1);
    //     }
    //   }
    //   this.yyzzImg = newUrl;
    //   this.yyzzFlag = this.yyzzImg.length;
    // },
    // // 删除-资质证书
    // delZzzs(val) {
    //   let newUrl = this.zzzsImg;
    //   for (var i = 0; i < newUrl.length; i++) {
    //     if (val == i) {
    //       newUrl.splice(i, 1);
    //     }
    //   }
    //   this.zzzsImg = newUrl;
    //   this.zzzsFlag = this.zzzsImg.length;
    // },
    
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    
  },
  created() {
    this.getInit(); // 查询列表
    this.getprovince(); // 城区
    this.getSsq(); // 省市区
  }
}
</script>
<style scoped>
/* 基本信息 */
.watch_msg {
  width: 96%;
  margin: 0 auto;
}
.typeface {
  font-size: 15px;
  line-height: 33px;
}
.watch_tab {
  margin: 15px 0;
}
/* tab表格 */
.tempTabs {
  width: 100%;
  margin: 10px auto;
}
.paginationFy {
  float: right;
  margin-top: 10px;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 多图 */
.upPictures {
  width: 88%;
  margin-top: 10px;
}
.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float:left;
  margin-right:10px;
  margin-bottom: 5px;
}
.seeLarge {
  width:80px;
  height:80px;
  cursor: pointer;
}
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
}
.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
}
.spPicWenan {
  width: 100%;
  height: 30px;
  display: inline-block;
  margin: 5px auto;
  color: #999;
}
</style>


// WEBPACK FOOTER //
// settledEnterprise.vue?6c23d3fb